<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <loader :isLoading="loadingData" />
          <template v-slot:headerTitle>
            <h4 class="card-title">Assign Publisher to Offer</h4>
          </template>
          <template v-slot:headerAction>
            <b-button @click="showModal" variant="primary">Add New</b-button>
            <b-modal ref="myModalRef" id="modal-4" size="lg" title="Add Publisher to Offer" hide-footer>
              <form class="mt-4" @submit.prevent="submitForm">
              <b-form-group>
                <label for="usertype">publisher</label><span class="text-danger"> *</span>
                <multiselect
                    v-model="items.user_id"
                    :options="publishers"
                    :multiple="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    label="text"
                    track-by="value"
                />
              </b-form-group>
              <b-form-group>
                <label for="usertype">Offer</label><span class="text-danger"> *</span>
                <multiselect
                    v-model="items.offer_id"
                    :options="offers"
                    :multiple="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    label="text"
                    track-by="value"
                />
              </b-form-group> 
              <b-form-group>
                <label for="usertype">Status</label><span class="text-danger"> *</span>
                      <b-form-select plain v-model="items.status" :options="user_status" size="lg">
                        <template v-slot:first>
                          <b-form-select-option :value="null">Select Status</b-form-select-option>
                        </template>
              </b-form-select>
              </b-form-group>
                <b-button type="submit" variant="primary" :disabled="!allFieldsValid">Submit</b-button>
              </form>
            </b-modal>
          </template>
          <template>
            <b-row>

              <b-col md="12" class="table-responsive">
                <b-col sm="0" md="3" class="my-1" style="float: left;">
              <div>Total Rows : {{ totalRows}}</div>
            </b-col>
              <b-col sm="0" md="3" class="my-1" style="float: right;">
      <b-form-group
        label="Page"
        label-for="per-page-select"
        label-cols-sm="2"
        label-cols-md="2"
        label-cols-lg="2"
        label-align-sm="right"
        label-size="sm"
        class="mb-0"
      >
        <b-form-select
          id="per-page-select"
          v-model="perPage"
          :options="pageOptions"
          @change="handleFilterBlur"
          size="sm"
        ></b-form-select>
      </b-form-group>
    </b-col>
              <b-table bordered hover 
              :items="pub_offer_rows" 
              :fields="columns"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              stacked="md"
              show-empty
              small
              >
              <template slot="top-row" slot-scope="{ fields }">
                <td v-for="field in fields" :key="field.key" >
                  <template v-if="field.key === 'offer'">
                    <multiselect
                    v-model="offerNameFilter"
                    :options="[ { value: 'null', text: 'All' }, ...offers ]"
                    @select="handleFilterBlur"
                    @remove="handleFilterRemove('offer')"
                    :multiple="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    label="text"
                    track-by="value"
                    />
                  </template>
                 <template v-else-if="field.key === 'user'">
                    <multiselect
                    v-model="publisherNameFilter"
                    :options="[ { value: 'null', text: 'All' }, ...publishers ]"
                    @select="handleFilterBlur"
                     @remove="handleFilterRemove('publisher')"
                    :multiple="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    label="text"
                    track-by="value"
                    />
                  </template>
                  <template v-if="field.key === 'status_text'">
                    <b-form-select v-model="filters[field.key]"  @change="handleFilterBlur" :options="user_status" prepend-top>
                      <template #first>
                        <b-form-select-option :value="null">All</b-form-select-option>
                      </template>
                    </b-form-select>
                 </template>
                </td>
              </template>
                  <template v-slot:cell(offer)="data">
                    <span>{{ data.item.offer }}</span>
                    <!-- <input type="text" v-model="data.item.offer" v-else class="form-control"> -->
                  </template>
                  <template v-slot:cell(user)="data">
                    <span>{{ data.item.user }}</span>
                    <!-- <input type="text" v-model="data.item.user" v-else class="form-control"> -->
                  </template>
                  <template v-slot:cell(status_text)="data">
                    <b-button variant=" iq-bg-danger" @click="update(data.item)" v-if="data.item.status_text == 'BLACK LIST'" size="sm">{{ data.item.status_text}}</b-button>
                    <b-button variant=" iq-bg-success" @click="update(data.item)" v-else size="sm">{{ data.item.status_text}}</b-button>
                  </template>
                  <template v-slot:cell(action)="data">
                  <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="ri-delete-bin-line m-0"></i></b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </template>
          <template>
        <b-col sm="3" md="2" class="my-1" v-if="this.pub_offer_rows.length > 0">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        prev-text="Previous"
        next-text="Next"
        first-text="First"
        last-text="Last"
      ></b-pagination>
    </b-col>
  </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
  
</template>
<script>
import { sofbox } from '../../config/pluginInit'
import Offer from '../../Apis/offer'
import UserControl from '../../Apis/usercontrol'
import Common from '../../Apis/common'
import Loader from '../../components/Loader.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: 'UiDataTable',
  mounted () {
    sofbox.index(),
    this.loadData();
  },
  components: {
    Loader,Multiselect
  },
  methods: {
    default () {
      return {
        items:{
        _id:'',
        user_id: '',
        offer_id: '',
        status: '',
        },
        editable: false,
        allerros:{},
      }
    },
    showModal(){
      this.items = this.default()
      this.allerros = {}
      this.$refs.myModalRef.show();
    },
    async update(item) {
      this.loadingData = true;
      this.items._id = item._id;
      this.items.status = item.status;
      try{
        let response = await Offer.updateUserOfferStatus(this.items)
        if(response.status == 200){
          this.$toast.info('Status Updated Successfully!', {
                    position: 'top-center'
                });
          this.listUserOffer()
        }else{
          this.allerros = response.data.errors
        }
        this.loadingData = false;
      }catch(error){
        this.loadingData = false;
      }
    },
    submit (item) {
      this.items = item;
      this.submitForm();
      item.editable = false
    },
    async submitForm(){
      this.loadingData = true;
      this.items.user_id = this.checkValue(this.items.user_id);
      this.items.offer_id = this.checkValue(this.items.offer_id);
      try{
        let response = await Offer.storeUserOffer(this.items)
        if(response.status == 201){
          const message = response.data.message;
          this.$toast.info(message, {
                    position: 'top-center'
                });
          this.listUserOffer()
          this.items = this.default()
          this.$refs.myModalRef.hide();
        }else{
          this.allerros = response.data.errors
        }
        this.loadingData = false;
      }catch(error){
        this.loadingData = false;
      }
    },
    checkValue(value){
      if(value.value){
        return value.value
      }else{
        return value
      }
    },
    async remove (item) {
      if(confirm('Are you sure to delete this Relation?')){
        try{
          let response = await Offer.deleteUserOffer(item._id)
          if(response.status == 200){
            this.listUserOffer()
          }else{
            this.allerros = response.data.errors
          }
        }catch(error){
        }
      }
    },
    handleFilterBlur() {
      if(typeof this.publisherNameFilter == 'object'){
          this.filters.user = this.publisherNameFilter.value;
      }
      if(typeof this.offerNameFilter == 'object'){
        this.filters.offer = this.offerNameFilter.value;
      }
       this.currentPage = 1; // Reset the current page when filtering
        this.listUserOffer(); // Call listCountry when filter input is blurred
      },
      handleFilterRemove(filterType) {
      if (filterType === 'publisher') {
        this.publisherNameFilter = null;
        this.filters.user = '';
      } else if (filterType === 'offer') {
        this.offerNameFilter = null;
        this.filters.offer = '';
      }
      this.currentPage = 1;
      this.listUserOffer();
    },
    async listUserOffer(){
      this.loadingData = true;
      try{
        const params = {
        page: this.currentPage,
        perPage: this.perPage,
        ...this.filters
      };
      let response = await Offer.listUserOffer(params)
        if(response.status == 200){
          let data = response.data.data.data
          console.log(data)
          //add editable and incremental id in each row
          data.forEach((element) => {
            element.editable = false
            const userD = this.publishers.find(x => x.value == element.user_id);
            element.user = userD ? userD.text : '';
            const offerD = this.offers.find(x => x.value == element.offer_id);
            element.offer = offerD ? offerD.text : '';
            const statusD = this.user_status.find(x => x.value == element.status);
            element.status_text = statusD ? statusD.text : '';
          });
          this.pub_offer_rows = data
          console.log(this.pub_offer_rows)
          this.totalRows = response.data.data.total
        }
        this.loadingData = false;
      }catch(error){
        this.loadingData = false;
      }
    },
    async listPublisher(){
      try{
        let response = await UserControl.listPublisher()
        if(response.status == 200){
          let data = response.data.data
          for(const key in data){
            this.publishers.push({ value: data[key]._id, text: data[key].int_id+'-'+data[key].username})
          }
        }
      }catch(error){
      }
      console.log('publishers',this.publishers)
    },
    async listActiveOffer(){
      try{
        let response = await Offer.listPrivateOffer()
        if(response.status == 200){
          let data = response.data.data
          for(const key in data){
            this.offers.push({ value: data[key]._id, text:data[key].int_id+'-'+data[key].name })
          }
        }
      }catch(error){
      }
      console.log('offers',this.offers)
    },
    async listStatus(){
      try{
        let response = await Common.listStatus()
        if(response.status == 200){
          let p_model = response.data.assign_offer_status
          
          for(const key in p_model){
            this.user_status.push({ value: key, text: p_model[key] })
          }
        }
      }catch(error){
      }
      console.log('user_status',this.user_status)
    },
    async loadData() {
      try {
        await this.listPublisher();
        await this.listActiveOffer();
        await this.listStatus();
        await this.listUserOffer();
      } catch (error) {
        console.error('Error loading data:', error);
      }
    }
  },
  data () {
    return {
      columns: [
        { label: 'Publisher', key: 'user', class: 'text-left', sortable: true },
        { label: 'Offer', key: 'offer', class: 'text-left', sortable: true },
        { label: 'status', key: 'status_text', class: 'text-left', sortable: true },
        { label: 'Action', key: 'action', class: 'text-center' }
      ],
      filters: {
        user: '',
        offer: '',
        status_text: '',
      },
      pub_offer_rows: [],
      items: {
        _id:'',
        offer_id: null,
        user_id: null,
        status: 0,
      },
      allerros:{},
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10,20,50,100],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      publishers:[],
      offers:[],
      user_status:[],
      loadingData:true,
      publisherNameFilter: 'null',
      offerNameFilter: 'null'
    }
  }, 
  watch: {
    // Watch for changes in currentPage and fetchData accordingly
    currentPage: 'listUserOffer',
  },
  computed: {
    allFieldsValid() {
          return this.items.user_id && this.items.offer_id && this.items.status;
      },

  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.table-responsive{
  overflow-x:unset !important ;
}
</style>